import { Box, BoxProps } from "@mui/material";
import { FunctionComponent, ReactElement, ReactNode } from "react";


interface ContainerModalProps {
  children: ReactElement | ReactElement[] | ReactNode
  props?: BoxProps
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 1,
};

const ContainerModal: FunctionComponent<ContainerModalProps> = ({ children, props }) => {
  return ( <>
   <Box sx={style}  {...props}>
        {
          children
        }
      </Box>
  </> );
}

export default ContainerModal;
